/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing($routeProvider: RouteProvider): void {
  $routeProvider
    .when('/sales/trade-ins', {
      templateUrl: require('./trade-ins.template.html'),
      title: 'Inzahlungnahmen',
    });
}
